
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/tmpfs/builds/maltcommunity/malt/apps/malt/lib-front-monitoring/nuxt-sentry-v2-module/src/runtime/sentry.client.config.ts")
            }
          });